module.exports = __webpack_public_path__ + "static/media/Huis-1-4.459138f6.jpg";